import {Component, NgModule, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Router, ActivatedRoute, Params} from '@angular/router';
import {AuthService} from "../services/auth.service";
import {AlertService} from "../services/alert.service";
import {SideNavComponent} from "../shared/sidenav";
import {DialogService} from "../services/dialog.service";
import {HttpClient, HttpParams} from "@angular/common/http";
import {EnvService} from "../services/env.service";
// import {CaptchaComponent} from "angular-captcha";
import {MicroCaptchaComponent} from "../shared/captcha/micro-captcha.component";
import {SysService} from "../services/sys.service";

@Component({
  templateUrl: 'login.component.html'
})

export class LoginComponent implements OnInit, OnDestroy {
  username: string;
  email: string;
  msisdn: string;
  password: string = '';
  confirmPassword: string = '';
  loading = false;
  loginFailed: boolean;
  pwConfig:any;
  liff:any;
  resettingPassword:boolean = false;
  requestingOtp:boolean = false;
  awaitingOtp:boolean = false;
  passwordResetRsp:any;
  pwResetRsp:any;
  otp:any;
  timer:any;
  otpExpiryProgress:number = 0;
  reminderInfo:string = 'username';
  returnUrl:string;

  // @ViewChild(MicroCaptchaComponent) captchaComponent:MicroCaptchaComponent;
  private deleteLoggedIn: boolean = false;
  private deleteConfirmed: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public env:EnvService,
    private authService: AuthService,
    private http: HttpClient,
    private alertService: AlertService,
    private dialogService: DialogService,
    private sysService: SysService
  ) { }

  ngOnInit() {
    this.authService.logout(false);

    this.route.queryParams
      .subscribe((params: Params) => {
        this.returnUrl = params['returnUrl'];
      });

    this.http.get(`${this.env.e.url}/auth/pwConfig`).subscribe(
      data => {
        this.pwConfig = data;
      }
    );

    if (this.sysService.isAvailable('aprild')) {
      this.http.get(`${this.env.e.url}/april/liff`).subscribe(
        data => {
          this.liff = data;
        }
      );
    }

    this.timer = setInterval(()=> {
      if (this.awaitingOtp && this.passwordResetRsp && !this.passwordResetRsp.error && this.passwordResetRsp.expiryDate) {
        this.otpExpiryProgress = Math.max(0, (this.passwordResetRsp.expiryDate - new Date().getTime()) / (300000)) * 100;
      }
    }, 1000);
  }

  ngOnDestroy(): void {
    clearInterval(this.timer);
  }

  getCaptchaCode() {
    if (this.pwConfig.captchaEnabled) {
      // return this.captchaComponent.getCaptchaCode();
    }
    return '';
  }

  getCaptchaId() {
    if (this.pwConfig.captchaEnabled) {
      // return this.captchaComponent.getCaptchaId();
    }
    return '';
  }

  reloadCaptcha() {
    if (this.pwConfig.captchaEnabled) {
      // this.captchaComponent.reloadImage();
    }
  }

  login() {
    // if (this.pwConfig.captchaEnabled && !this.captchaComponent.hasCaptchaCode()) {
    //   this.alertService.warn("Robot Verification Required");
    //   return;
    // }

    this.loginFailed = false;
    this.loading = true;
    this.authService.login(this.username, this.password,
      this.getCaptchaCode(), this.getCaptchaId())
      .subscribe(
        user => {
          if (this.returnUrl) {
            let url = decodeURIComponent(this.returnUrl);
            this.router.navigateByUrl(url).then(value => {
              if (!value) {
                this.defaultNav();
              }
            });
          } else {
            this.defaultNav();
          }
        },
        error => {
          this.loginFailed = true;
          this.loading = false;
          this.reloadCaptcha();
          this.alertService.warn("Login failed: " + error);
        });
  }

  defaultNav() {
    this.router.navigate([this.authService.isSystemUser() || this.authService.hasService('SYSTEM') || this.authService.hasService('ALARMING') ? '/alarms' : '/me' ]);
  }

  resetPassword() {
    this.dialogService.confirm("Reset Password?", `Are you sure you want to reset your password?`, "Reset Password").subscribe(confirmed => {
      if (confirmed) {
        var req = {
          username: this.username,
          email: this.email,
          msisdn: this.msisdn,
          captchaCode: this.getCaptchaCode(),
          captchaId: this.getCaptchaId()
        }
        this.requestingOtp = true;
        this.http.post(`${this.env.e.url}/auth/requestPasswordReset`, req).subscribe(
          data => {
            this.passwordResetRsp = data;
            if (this.passwordResetRsp.error) {
              this.alertService.warn(this.passwordResetRsp.error);
              this.reloadCaptcha();
            } else {
              this.awaitingOtp = true;
            }
            this.requestingOtp = false;
          },
          error => {
            this.reloadCaptcha();
          }
        );
      }
    });
  }

  sendOtp() {
    var req = {
      username: this.username,
      email: this.email,
      msisdn: this.msisdn,
      otp: this.otp,
      password: this.password,
      confirmPassword: this.confirmPassword,
      captchaCode: this.getCaptchaCode(),
      captchaId: this.getCaptchaId()
    }
    this.http.post(`${this.env.e.url}/auth/pwReset`, req).subscribe(
      data => {
        this.pwResetRsp = data;
        if (this.pwResetRsp.error) {
          this.alertService.warn(this.pwResetRsp.error);
          this.reloadCaptcha();
        } else {
          this.awaitingOtp = false;
          this.resettingPassword = false;
          this.alertService.info(`Password reset successful!`);
        }
      },
      error => {
        this.reloadCaptcha();
      }
    );
  }

  containsUppercase() {
    return /[A-Z]/.test(this.password);
  }

  containsLowercase() {
    return /[a-z]/.test(this.password);
  }

  containsNumber() {
    return /[0-9]/.test(this.password);
  }

  containsSpecial() {
    return /[\W_]/.test(this.password);
  }

  isValidPassword() {
    return this.password === this.confirmPassword &&
      this.password.length >= 6 &&
      this.containsUppercase() &&
      this.containsLowercase() &&
      this.containsNumber() &&
      this.containsSpecial();
  }

  register() {
    this.router.navigate(['/register'], {queryParams: {returnUrl: this.router.routerState.snapshot.url}});
  }

  protected deleteAccount() {
    if (!this.deleteLoggedIn) {
      var username = !!this?.username?.trim();
      var password = !!this?.password?.trim();
      if (!this.username || !this.password) {
        this.alertService.warn("Please enter your username and password");
        return;
      }

      this.loading = true;
      this.authService.login(this.username, this.password, this.getCaptchaCode(), this.getCaptchaId())
        .subscribe(
          user => {
            this.loading = false;
            this.deleteLoggedIn = true;
            this.deleteAccount();
          },
          error => {
            this.deleteLoggedIn = false;
            this.loading = false;
            this.reloadCaptcha();
            this.alertService.warn("Login failed: " + error);
          });
      return;
    }

    if (this.deleteLoggedIn && !this.deleteConfirmed) {
      this.dialogService.confirm(`Delete Account ${this.username}?`, `This will delete your existing account and personal data.</br></br>Are you sure you want to delete your account?`, "Delete Account")
        .subscribe(confirmed => {
            this.deleteConfirmed = confirmed;
            if (!confirmed) {
              this.deleteLoggedIn = false;
              this.authService.logout(false);
              return;
            }
            this.deleteAccount();
        });
      return;
    }

    this.http.put(`${this.env.e.url}/auth/deregistration`,  this.authService.user.id)
      .subscribe(
        data => {
          this.alertService.info(`Account ${this.username} deleted`);
          this.deleteConfirmed = false;
          this.deleteLoggedIn = false;
          this.authService.logout(false);
          this.username = undefined;
          this.password = undefined;
        },
        error => {
          if (error.error?.error) {
            let errorMsg = error.error.error as string;
            let alertDuration = 10_000;
            if (error.status === 403 && errorMsg.toLowerCase().includes('contact your system administrator')) {
              alertDuration = 0;
            }
            this.alertService.warn(error.error.error, undefined, undefined, alertDuration);
          } else {
            this.alertService.warn('Something went wrong');
          }
          this.deleteConfirmed = false;
          this.deleteLoggedIn = false;
          this.authService.logout(false);
        }
      );

  }
}

